import axios from 'axios'

const client = axios.create({
    baseURL: 'https://contact.rasti.ca/api',
    timeout: 30000,
    headers: {
        Accept: 'application/json',
    },
})

export default client
